import styles from "./ClaimingConversionCancelPolicy.module.scss"

type Props = {
	// cancy が返すキャンセル料テキスト (例: "予約金額の100%")。
	// 空のときは出さない判定を呼び出し側で行う (同意文・ボタン文言の出し分けと揃えるため)
	cancelConditionTexts: string[]
}

// 請求転換 (前回キャンセル料を免除して再予約を案内した) の再予約で出す特殊キャンセルポリシー。
// 「本画面からの予約は請求の代わりなので、お客様都合でキャンセルされたら理由を問わず請求する」を
// 予約前 (確認モーダル) と予約後 (完了画面) の両方で同じ見た目・同じ文面で出すための共通コンポーネント。
// 構成: 赤い帯 (見出し) → 結論 (大きく) → キャンセル料 (数字を大きく) → 理由 (小さく)
// NOTE: サロン都合・緊急事態のキャンセルは cancy 側で請求しない (Cancel.update_as_claiming_conversion_recancel) ため、
//       文面は「お客様のご都合による」に限定している
const ClaimingConversionCancelPolicy = ({ cancelConditionTexts }: Props) => (
	<section className={styles.section} aria-label="キャンセルポリシー">
		<div className={styles.banner}>
			<span className={styles.banner_icon} aria-hidden="true">
				!
			</span>
			<span>重要：キャンセル料について</span>
		</div>
		<div className={styles.body}>
			{/* 結論を先に大きく。読まずに先へ進まれるのを防ぐ */}
			<p className={styles.lead}>
				このご予約をお客様のご都合で変更・キャンセルされた場合、
				<span className={styles.lead_strong}>
					理由を問わずキャンセル料を請求いたします
				</span>
			</p>
			<dl className={styles.fee}>
				<dt>キャンセル料</dt>
				{cancelConditionTexts.map((text, index) => (
					<dd key={index}>{text}</dd>
				))}
			</dl>
			<p className={styles.reason}>
				本画面からのご予約は、前回のキャンセル料のご請求に代えてご案内しているものです。そのため、お客様のご都合によるご予約の変更・キャンセルの場合は、その理由に関わらずキャンセル料が発生します。あらかじめご了承ください。
			</p>
		</div>
	</section>
)

export default ClaimingConversionCancelPolicy
